var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgIconsLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3836_458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.50908 0.00585938C2.03159 0.00585938 0.00390625 2.03349 0.00390625 4.51103V18.4914C0.00390625 20.9689 2.03154 22.9958 4.50908 22.9958H18.4894C20.9669 22.9958 22.9939 20.9689 22.9939 18.4914V4.51103C22.9939 2.03354 20.9669 0.00585938 18.4894 0.00585938H4.50908ZM5.6422 3.79966C6.8301 3.79966 7.5618 4.5795 7.58438 5.60459C7.58438 6.60704 6.83005 7.4088 5.61922 7.4088H5.59693C4.43164 7.4088 3.67846 6.60709 3.67846 5.60459C3.67846 4.57952 4.45443 3.79966 5.64217 3.79966H5.6422ZM15.879 8.59079C18.1636 8.59079 19.8762 10.084 19.8762 13.2928V19.2831H16.4043V13.6944C16.4043 12.2901 15.9018 11.3319 14.6453 11.3319C13.6861 11.3319 13.1144 11.9777 12.8634 12.6016C12.7717 12.8248 12.7492 13.1365 12.7492 13.4487V19.2831H9.27723C9.27723 19.2831 9.32279 9.81605 9.27723 8.83579H12.7499V10.3152C13.2112 9.60339 14.0365 8.59077 15.879 8.59077V8.59079ZM3.88325 8.83655H7.35517V19.2832H3.88325V8.83655Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3836_458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLinkedin);
export default __webpack_public_path__ + "static/media/icons-linkedin.f215dd78c294b1064b140b84d6c2309c.svg";
export { ForwardRef as ReactComponent };